module.exports = __webpack_public_path__ + "static/r3c3-47b1003a3189823eddd7d0bfb3b3f234.png";